module.exports = "/assets/67e9d3cdb81a911c4e2a63956e6e615f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/01.png
// module id = 951
// module chunks = 0